import Header from "@/components/common/Header/index";

const HeaderLayout = ({
                        children = null,
                        title = '',
                        rightComponent = null
                      }: HeaderLayoutProps) => (
    <div className="bg-white-subtle h-full w-full">
      <Header title={title}>
        {rightComponent}
      </Header>
      <div className="py-4 px-6 w-full print-full">
        {children}
      </div>
    </div>
  )
;

export default HeaderLayout;
